import React from 'react';
import './Home.scss';
import bannerImage from '../images/Teacher.jpeg'; // Adjust the path based on your directory structure

const Home = () => {
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="home">
      <h1 className="home__title">Welcome To English Enclave</h1>
      <img
        src={bannerImage}
        alt="Big banner"
        className="home__image"
      />
      <p className="home__text" style={{ fontStyle: 'Irish Grover' }}>
        Language Without Borders: Connect, Communicate, and Thrive.
      </p>
      <button className="home__button" onClick={() => scrollToSection('services')}>
        Get Started
      </button>
    </div>
  );
};

export default Home;
